import { TextField as TPATextField, TextFieldTheme } from '@wix/wix-ui-tpa/cssVars';
import classNames from 'classnames';
import React, { useCallback, useRef } from 'react';
import { useFocusFieldEvent } from '../../contexts/events-context';
import { ForcedState, useForcedState } from '../../contexts/forced-state-context';
import { classes } from '../../ui/text-input-field/text-input-field-wut.st.css';
export const TextInputWUT = _ref => {
  let {
    label,
    placeholder,
    required = false,
    value = '',
    onChange,
    onBlur,
    onFocus,
    type = 'text',
    disabled = false,
    readOnly,
    prefix,
    inputId,
    fieldId,
    ariaDescribedBy,
    hasError,
    className,
    dataHook,
    showPasswordTooltipText,
    hidePasswordTooltipText
  } = _ref;
  const forcedHover = useForcedState().includes(ForcedState.INPUT_FIELDS_HOVER);
  const inputRef = useRef(null);
  useFocusFieldEvent(() => {
    var _inputRef$current;
    (_inputRef$current = inputRef.current) == null || _inputRef$current.focus({
      preventScroll: true
    });
  }, fieldId);
  const handleChange = useCallback(event => {
    const newValue = event.target.value;
    onChange(newValue);
  }, [onChange]);
  return /*#__PURE__*/React.createElement(TPATextField, {
    ref: inputRef,
    id: inputId,
    type: type,
    error: hasError,
    newErrorMessage: true,
    value: value ? String(value) : '',
    className: classNames(classes.textField, classes.theme, className, {
      [classes.error]: hasError,
      [classes.hover]: forcedHover
    }),
    prefix: prefix,
    onChange: handleChange,
    required: required,
    disabled: disabled,
    placeholder: placeholder,
    onBlur: onBlur,
    onFocus: onFocus,
    "aria-label": label,
    theme: TextFieldTheme.Box,
    "aria-describedby": ariaDescribedBy,
    "aria-invalid": hasError,
    readOnlyCustom: readOnly,
    "data-hook": dataHook,
    showPasswordTooltipText: showPasswordTooltipText,
    hidePasswordTooltipText: hidePasswordTooltipText
  });
};
//# sourceMappingURL=text-input-wut.js.map